module.exports = __webpack_public_path__ + "static/media/noone.bf5cd29e.png";